import { BASE_URL, s3Path } from '../../general/variables';
import { getUrlParameter, makeKTBlock, makeSwal, nl2br } from '../../general/functions';
import { proposalList } from './setup';

const initListenerProposal = () => {
  // Begin Expo Package Proposal Section

  $('#formPostProposal').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#modalAddProposal .modal-dialog');
    let action = $(this).attr('action'),
      formData = new FormData(this);

    $.ajax({
      url: action, // your backend URL
      type: 'POST',
      data: formData,
      dataType: 'JSON',
      processData: false, // prevent jQuery from converting data
      contentType: false, // prevent jQuery from overriding content type
      success: function (response) {
        makeKTBlock('#modalAddProposal .modal-dialog', 'hide');
        const { code, header, message, status } = response;
        makeSwal(header, message, status);

        $('#formPostProposal')[0].reset();
        $('#formPostProposal').find('input').val('');
        $('#formPostProposal').find('textarea').val('');
        $('#formPostProposal').find('input[type="file"]').val('');
        $('#formPostProposal').find('#proposalFile').next().text('Choose File...');

        $('#modalAddProposal').modal('hide');
        proposalList.reload();
      },
      error: function (xhr, status, error) {
        makeKTBlock('#modalAddProposal .modal-dialog', 'hide');
        makeSwal('Error!', 'Error - Contact IT Division', 'error');
        console.error('Create proposal failed:', error);
      },
    });
  });

  $(document).on('click', '.btn-edit-proposal', function (e) {
    e.preventDefault();
    let rec_id = $(this).data('id');
    makeKTBlock('#modalEditProposal');

    $.ajax({
      url: `${BASE_URL}Expo_Packages/proposalShow?rec_id=${rec_id}&id=${getUrlParameter('id')}`,
      method: 'GET',
      dataType: 'JSON',
      success: function (response) {
        const { code, header, message, status, data } = response;

        if (data.FILE) {
          $('#proposalFileContainer').show();

          const isURL = data.FILE.startsWith('http://') || data.FILE.startsWith('https://');
          if (isURL) {
            let filename = data.FILE.split('/').pop();
            $('#currentProposalFile').html(`<a target="_blank" href="${data.FILE}">${filename}</a>`);
          } else {
            $('#currentProposalFile').html(`<a target="_blank" href="${s3Path}/Events/${getUrlParameter('id')}/Proposal/${data.FILE}">${data.FILE}</a>`);
          }
        } else {
          $('#proposalFileContainer').hide();
          $('#currentProposalFile').html('');
        }

        $('#proposalID').val(data.ID);
        $('#editProposalDetail').html(nl2br($.trim(data.DESCRIPTION)));

        setTimeout(() => {
          makeKTBlock('#modalEditProposal', 'hide');
          $('#modalEditProposal').modal('show');
        }, 800);
      },
      error: function (error) {
        makeKTBlock('#modalEditProposal', 'hide');
        const { code, header, message, status } = error;
        makeSwal(header, message, status);
      },
    });
  });

  $('#formEditProposal').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#modalEditProposal .modal-dialog');
    let action = $(this).attr('action'),
      formData = new FormData(this);

    $.ajax({
      url: action,
      method: 'POST',
      data: formData,
      dataType: 'JSON',
      processData: false, // prevent jQuery from converting data
      contentType: false, // prevent jQuery from overriding content type
      success: function (resp) {
        makeKTBlock('#modalEditProposal .modal-dialog', 'hide');
        const { header, message, status } = resp;
        makeSwal(header, message, status);

        $('#formEditProposal').find('input').val('');
        $('#formEditProposal').find('input[type="file"]').val('');

        $('#modalEditProposal').modal('hide');
        proposalList.reload();
      },
      error: function (data) {
        makeKTBlock('#modalEditProposal .modal-dialog', 'hide');
        makeSwal('Error!', 'Error - Contact IT Division', 'error');
        console.log(data);
      },
    });
  });

  $(document).on('click', '.btn-delete-proposal', function (e) {
    e.preventDefault();

    makeKTBlock('#promotion');
    let rec_id = $(this).data('id');

    Swal.fire({
      title: 'Information!',
      html: 'Are you sure want to delete this PROPOSAL, this action cannot be revert?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Delete',
    }).then((result) => {
      if (result.isConfirmed) {
        $.ajax({
          url: `${BASE_URL}Expo_Packages/proposalDestroy`,
          method: 'POST',
          dataType: 'JSON',
          data: {
            id: getUrlParameter('id'),
            rec_id: rec_id,
          },
          success: function (response) {
            const { code, header, message, status } = response;

            makeSwal(header, message, status);
            makeKTBlock('#promotion', 'hide');
            proposalList.reload();
          },
          error: function (error) {
            const { code, header, message, status } = error;
            makeSwal(header, message, status);
            makeKTBlock('#promotion', 'hide');
          },
        });
      }
    });
  });
  // End Expo Package Proposal Section
};

export { initListenerProposal };
